









































import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  Ref,
  watch,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import {
  getNotifyGroups,
  deleteNotifyGroup,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import useAuth from '@/use/useAuth';

const Index = defineComponent({
  setup() {
    const { route } = useRouter();
    const { hasPermission } = useAuth();
    const refetchQuery = ref(false);
    const tempNotifyGroupDelete = -1;
    const confirmModal = ref(null);
    const roles: Ref<{ id: number; name: string }[]> = ref([]);
    async function getNotifyGroupData() {
      const result = await getNotifyGroups({});
      roles.value = result.data;
    }
    onMounted(async () => {
      await getNotifyGroupData();
    });

    async function deleteNotifyGroupFunction(id: number) {
      await deleteNotifyGroup(id);
      await getNotifyGroupData();
    }

    // ==== Use Format ==== //
    function useDateTimeFormat(date: any) {
      if (!date) return '';
      return `${useFormat
        .date(date)
        .displayShortThaiDate()} เวลา ${date.substring(11, 16)}`;
    }

    watch(() => route.value.params.roleId, (newVal, oldVal) => {
      if (newVal !== oldVal && newVal !== '') {
        refetchQuery.value = true;
      }
    });

    return {
      roles,
      refetchQuery,
      tempNotifyGroupDelete,

      useDateTimeFormat,
      getNotifyGroupData,
      deleteNotifyGroupFunction,
    };
  },
  components: {
    CommonModalWithPreset,
  },
});

export default Index;
